var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('v-overlay',{attrs:{"value":_vm.isLoading,"z-index":"1000"}},[_c('div',{staticClass:"loading-overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":80,"width":12}}),_c('p',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.loadingMsg))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }